module.exports = __webpack_public_path__ + "static/media/Linearicons-Free.65060723.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/architect/components/icons/linearicons/Linearicons-Free.woff
// module id = 324
// module chunks = 0